import {Locale} from './locale';

interface ShopConfig {
  shopId: number;
  childShopId: number;
}

export const mobileShopIdConfig: Record<Locale, ShopConfig> = {
  [Locale.en_ZZ]: {
    shopId: 692,
    childShopId: 692,
  },
  [Locale.es_ZZ]: {
    shopId: 693,
    childShopId: 693,
  },
  [Locale.de_DE]: {
    shopId: 139,
    childShopId: 428,
  },
  [Locale.en_DE]: {
    shopId: 688,
    childShopId: 688,
  },
  [Locale.de_AT]: {
    shopId: 200,
    childShopId: 436,
  },
  [Locale.en_AT]: {
    shopId: 731,
    childShopId: 731,
  },
  [Locale.nl_NL]: {
    shopId: 545,
    childShopId: 546,
  },
  [Locale.en_NL]: {
    shopId: 732,
    childShopId: 732,
  },
  [Locale.de_CH]: {
    shopId: 431,
    childShopId: 460,
  },
  [Locale.it_CH]: {
    shopId: 715,
    childShopId: 715,
  },
  [Locale.fr_CH]: {
    shopId: 566,
    childShopId: 567,
  },
  [Locale.en_CH]: {
    shopId: 730,
    childShopId: 730,
  },
  [Locale.nl_BE]: {
    shopId: 558,
    childShopId: 559,
  },
  [Locale.fr_BE]: {
    shopId: 562,
    childShopId: 563,
  },
  [Locale.pl_PL]: {
    shopId: 550,
    childShopId: 551,
  },
  [Locale.cs_CZ]: {
    shopId: 554,
    childShopId: 555,
  },
  [Locale.sk_SK]: {
    shopId: 586,
    childShopId: 587,
  },
  [Locale.ro_RO]: {
    shopId: 594,
    childShopId: 595,
  },
  [Locale.hu_HU]: {
    shopId: 590,
    childShopId: 591,
  },
  [Locale.sl_SI]: {
    shopId: 617,
    childShopId: 618,
  },
  [Locale.lv_LV]: {
    shopId: 622,
    childShopId: 623,
  },
  [Locale.ru_LV]: {
    shopId: 717,
    childShopId: 717,
  },
  [Locale.lt_LT]: {
    shopId: 627,
    childShopId: 628,
  },
  [Locale.et_EE]: {
    shopId: 632,
    childShopId: 633,
  },
  [Locale.ru_EE]: {
    shopId: 716,
    childShopId: 716,
  },
  [Locale.bg_BG]: {
    shopId: 642,
    childShopId: 643,
  },
  [Locale.da_DK]: {
    shopId: 654,
    childShopId: 654,
  },
  [Locale.fr_FR]: {
    shopId: 658,
    childShopId: 658,
  },
  [Locale.sv_SE]: {
    shopId: 655,
    childShopId: 655,
  },
  [Locale.es_ES]: {
    shopId: 670,
    childShopId: 670,
  },
  [Locale.it_IT]: {
    shopId: 671,
    childShopId: 671,
  },
  [Locale.fi_FI]: {
    shopId: 656,
    childShopId: 656,
  },
  [Locale.en_IE]: {
    shopId: 657,
    childShopId: 657,
  },
  [Locale.hr_HR]: {
    shopId: 637,
    childShopId: 638,
  },
  [Locale.pt_PT]: {
    shopId: 685,
    childShopId: 685,
  },
  [Locale.el_GR]: {
    shopId: 686,
    childShopId: 686,
  },
  [Locale.no_NO]: {
    shopId: 687,
    childShopId: 687,
  },
  [Locale.ar_SA]: {
    shopId: 694,
    childShopId: 694,
  },
  [Locale.en_SA]: {
    shopId: 695,
    childShopId: 695,
  },
  [Locale.he_IL]: {
    shopId: 696,
    childShopId: 696,
  },
  [Locale.en_IL]: {
    shopId: 697,
    childShopId: 697,
  },
  [Locale.el_CY]: {
    shopId: 705,
    childShopId: 705,
  },
  [Locale.fr_LU]: {
    shopId: 706,
    childShopId: 706,
  },
};

export const desktopShopIdConfig: Record<Locale, ShopConfig> = {
  [Locale.en_ZZ]: {
    shopId: 692,
    childShopId: 692,
  },
  [Locale.es_ZZ]: {
    shopId: 693,
    childShopId: 693,
  },
  [Locale.de_DE]: {
    shopId: 139,
    childShopId: 605,
  },
  [Locale.en_DE]: {
    shopId: 688,
    childShopId: 688,
  },
  [Locale.de_AT]: {
    shopId: 200,
    childShopId: 606,
  },
  [Locale.en_AT]: {
    shopId: 731,
    childShopId: 731,
  },
  [Locale.nl_NL]: {
    shopId: 545,
    childShopId: 609,
  },
  [Locale.en_NL]: {
    shopId: 732,
    childShopId: 732,
  },
  [Locale.de_CH]: {
    shopId: 431,
    childShopId: 607,
  },
  [Locale.fr_CH]: {
    shopId: 566,
    childShopId: 608,
  },
  [Locale.it_CH]: {
    shopId: 715,
    childShopId: 715,
  },
  [Locale.en_CH]: {
    shopId: 730,
    childShopId: 730,
  },
  [Locale.nl_BE]: {
    shopId: 558,
    childShopId: 610,
  },
  [Locale.fr_BE]: {
    shopId: 562,
    childShopId: 611,
  },
  [Locale.pl_PL]: {
    shopId: 550,
    childShopId: 612,
  },
  [Locale.cs_CZ]: {
    shopId: 554,
    childShopId: 613,
  },
  [Locale.sk_SK]: {
    shopId: 586,
    childShopId: 614,
  },
  [Locale.ro_RO]: {
    shopId: 594,
    childShopId: 616,
  },
  [Locale.hu_HU]: {
    shopId: 590,
    childShopId: 615,
  },
  [Locale.sl_SI]: {
    shopId: 617,
    childShopId: 621,
  },
  [Locale.lv_LV]: {
    shopId: 622,
    childShopId: 626,
  },
  [Locale.ru_LV]: {
    shopId: 717,
    childShopId: 717,
  },
  [Locale.lt_LT]: {
    shopId: 627,
    childShopId: 631,
  },
  [Locale.et_EE]: {
    shopId: 632,
    childShopId: 636,
  },
  [Locale.ru_EE]: {
    shopId: 716,
    childShopId: 716,
  },
  [Locale.bg_BG]: {
    shopId: 642,
    childShopId: 646,
  },
  [Locale.da_DK]: {
    shopId: 654,
    childShopId: 654,
  },
  [Locale.fr_FR]: {
    shopId: 658,
    childShopId: 658,
  },
  [Locale.sv_SE]: {
    shopId: 655,
    childShopId: 655,
  },
  [Locale.es_ES]: {
    shopId: 670,
    childShopId: 670,
  },
  [Locale.it_IT]: {
    shopId: 671,
    childShopId: 671,
  },
  [Locale.fi_FI]: {
    shopId: 656,
    childShopId: 656,
  },
  [Locale.en_IE]: {
    shopId: 657,
    childShopId: 657,
  },
  [Locale.hr_HR]: {
    shopId: 637,
    childShopId: 638,
  },
  [Locale.pt_PT]: {
    shopId: 685,
    childShopId: 685,
  },
  [Locale.el_GR]: {
    shopId: 686,
    childShopId: 686,
  },
  [Locale.no_NO]: {
    shopId: 687,
    childShopId: 687,
  },
  [Locale.ar_SA]: {
    shopId: 694,
    childShopId: 694,
  },
  [Locale.en_SA]: {
    shopId: 695,
    childShopId: 695,
  },
  [Locale.he_IL]: {
    shopId: 696,
    childShopId: 696,
  },
  [Locale.en_IL]: {
    shopId: 697,
    childShopId: 697,
  },
  [Locale.el_CY]: {
    shopId: 705,
    childShopId: 705,
  },
  [Locale.fr_LU]: {
    shopId: 706,
    childShopId: 706,
  },
};
